function init() {
	_toggleSubmitButton();
}

function _toggleSubmitButton() {
	const $input = $(".js-data-accept").find("input");

	$input.on("click", function () {
		const $this = $(this);
		const $submitButton = $this.closest(".js-data-accept").find("button[type='submit']");

		$submitButton.prop("disabled", !$this.is(":checked"));
	});
}

export { init };
